import React, { useState } from 'react';
import SimpleSlider from './image-slider';
import {
  TickOneIcon,
  OneFacebookIcon,
  OneInstagramIcon,
  OneTikTokIcon,
} from '../../atoms/icons';
import { redirectToProductDetails } from '../../../utils';
import NoImage from '../../../assets/images/no-image.png';
import defaultAvatar from '../../../assets/images/default-avatar.jpg';
import VideoSlider from './video-slider';

export const TemplateEight = ({
  expertiseData,
  preferredBrands,
  preferredProducts,
  redirectToBuyerPortal,
  redirectToShopPortal,
  cardDetails,
  schedulerEnabled,
}) => {
  const { seller, storefront } = cardDetails?.current?.config;
  const LogoUrl =
    storefront?.general?.longLogoImage?.url ||
    storefront?.general?.logoImage?.url ||
    null;

  const [isExpanded, setIsExpanded] = useState(false);

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <>
      <section className="eight-warpper">
        <div className="mainWrapper">
          <header className="flex justify-between items-center gap-6">
            {LogoUrl ? (
              <div className="logo-box max-w-56">
                <img src={LogoUrl} alt="logo" />
              </div>
            ) : (
              <h2 className="logo-text text-eightPrimary capitalize">
                {storefront?.general?.name}
              </h2>
            )}
          </header>
          <section className="header-block">
            <div>
              <div className="profile-bg">
                <div className="wrp-im">
                  <img
                    src={
                      seller?.profile?.avatar?.mediumUrl ||
                      seller?.profile?.avatar?.url ||
                      defaultAvatar
                    }
                    alt="profile image"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = defaultAvatar;
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="flex items-center">
              <div className="text-box">
                <h2 className="text-center font-bold md:text-5xl text-4xl font-tempOne capitalize text-black-main break-words">
                  {seller?.profile?.title}
                </h2>
                <div className="text-center ">
                  <div className="long-text">
                    <p
                      className={
                        isExpanded
                          ? 'full-text'
                          : seller?.profile?.about?.length > 600
                          ? 'clamped-text'
                          : ''
                      }
                    >
                      <p
                        className="font-normal italic md:text-xl text-base mt-5 "
                        dangerouslySetInnerHTML={{
                          __html: seller?.profile?.about,
                        }}
                      />
                    </p>
                    {seller?.profile?.about?.length > 600 && (
                      <button
                        className="read-text text-eightPrimary"
                        onClick={toggleReadMore}
                      >
                        {isExpanded ? 'Read Less' : 'Read More'}
                      </button>
                    )}
                  </div>
                </div>
                <div className="flex gap-4 justify-center items-center md:ml-0 ml-5 mt-8">
                  {seller?.profile?.facebookUrl && (
                    <a
                      href={seller?.profile?.facebookUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cursor-pointer"
                    >
                      <OneFacebookIcon className="text-eightPrimary" />
                    </a>
                  )}
                  {seller?.profile?.instagramUrl && (
                    <a
                      href={seller?.profile?.instagramUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cursor-pointer"
                    >
                      <OneInstagramIcon className="text-eightPrimary" />
                    </a>
                  )}
                  {seller?.profile?.tiktokUrl && (
                    <a
                      href={seller?.profile?.tiktokUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cursor-pointer"
                    >
                      <OneTikTokIcon className="text-eightPrimary" />
                    </a>
                  )}
                </div>
                <div className="flex justify-center">
                  <button
                    className="bg-eightPrimary text-white-main font-bold text-lg rounded-EightCustom px-10 py-4 flex items-center gap-4 mt-7"
                    onClick={() =>
                      redirectToShopPortal(storefront?.general?.shopUrl)
                    }
                  >
                    <span>Shop the store</span>
                  </button>
                </div>
              </div>
            </div>
          </section>
          {expertiseData?.length ? (
            <div
              className={
                expertiseData?.length === 0
                  ? 'visibility-hidden'
                  : 'visibility-auto'
              }
            >
              <div className="Expertise-box-wrp text-center">
                <h2 className="font-semibold md:text-4xl text-2xl font-tempOne mt-7 mb-7">
                  Expertise
                </h2>
                <ul className="grid md:gap-8 gap-4 four-list">
                  {expertiseData?.map((item, index) => (
                    <li key={index}>
                      <TickOneIcon className="text-eightPrimary" />
                      <span className="ml-2.5 font-normal text-base">
                        {item.name}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ) : (
            <div
              className={
                seller?.profile?.expertise
                  ? 'visibility-auto'
                  : 'visibility-hidden'
              }
            >
              <div className="Expertise-box-wrp text-center">
                <h2 className="font-semibold md:text-4xl text-2xl font-tempOne mt-7 mb-7">
                  Expertise
                </h2>
                <p
                  className="font-normal md:text-xl text-base mt-5 "
                  dangerouslySetInnerHTML={{
                    __html: seller?.profile?.expertise,
                  }}
                />
              </div>
            </div>
          )}
          {schedulerEnabled && (
            <div className="text-center mt-6">
              <button
                className="bg-eightPrimary text-white-main font-bold text-lg rounded-EightCustom px-10 py-4 flex items-center gap-4 mx-auto"
                onClick={() => redirectToBuyerPortal()}
              >
                <span>Book an appointment</span>
              </button>
            </div>
          )}
        </div>
      </section>
      <div className="eight-body">
        <div className="main-wrp">
          {seller?.profile?.galleryImages?.length ? (
            <div className="gallery-box">
              <h2 className="text-black-main font-semibold text-2xl font-tempOne md:mt-7 mb-5  text-center">
                Salon Gallery
              </h2>
              <div className="image-slider">
                <SimpleSlider images={seller?.profile?.galleryImages} />
              </div>
            </div>
          ) : (
            <></>
          )}
          {seller?.profile?.galleryVideoLinks?.length ? (
            <>
              <div className="flex flex-col lg:w-52 flex-1 video-slider">
                <h2 className="text-black-main font-semibold text-2xl font-tempOne mt-7 mb-5  text-center">
                  Salon Videos
                </h2>
                <VideoSlider videos={seller?.profile?.galleryVideoLinks} />
              </div>
            </>
          ) : (
            <></>
          )}
          <div>
            {preferredProducts?.length ? (
              <div
                className={
                  preferredProducts?.length === 0
                    ? 'visibility-hidden'
                    : 'visibility-auto'
                }
              >
                <h2 className="text-black-main font-semibold text-2xl font-tempOne mt-7 mb-5 md:text-left text-center">
                  My Favorite Products
                </h2>
                <div className="grid grid-cols-2 md:gap-4 gap-2 flex-wrap justify-center">
                  {preferredProducts?.slice(0, 4).map((product, index) => (
                    <div
                      key={index}
                      className="image-wrp cursor-pointer"
                      onClick={() =>
                        redirectToProductDetails(
                          storefront?.general?.shopUrl +
                            '/products/' +
                            product?.slug
                        )
                      }
                    >
                      <img
                        src={
                          product?.primaryImage?.mediumUrl ||
                          product?.primaryImage?.thumbUrl ||
                          NoImage
                        }
                        alt={`Product ${index + 1}`}
                      />
                    </div>
                  ))}
                </div>
              </div>
            ) : preferredBrands?.length ? (
              <div
                className={
                  preferredBrands?.length === 0
                    ? 'visibility-hidden'
                    : 'visibility-auto'
                }
              >
                <h2 className="text-black-main font-semibold text-2xl font-tempOne mt-7 mb-5 md:text-left text-center">
                  My Favorite Brands
                </h2>
                <div className="grid grid-cols-2 md:gap-4 gap-2 flex-wrap justify-center">
                  {preferredBrands?.slice(0, 4).map((product, index) => (
                    <div
                      key={index}
                      className="image-wrp cursor-pointer"
                      onClick={() =>
                        redirectToProductDetails(
                          storefront?.general?.shopUrl +
                            '/brands/' +
                            product?.slug
                        )
                      }
                    >
                      <img
                        src={
                          product?.coverImage?.mediumUrl ||
                          product?.coverImage?.thumbUrl ||
                          NoImage
                        }
                        alt={`Product ${index + 1}`}
                      />
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
